"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconsModule = _interopRequireDefault(require("./icons.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
  var id = props.id,
      children = props.children,
      className = props.className;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: "".concat(_iconsModule.default.icon, " ").concat(className ? (0, _classnames.default)(className) : "")
  }, children);
};

var _default = Icon;
exports.default = _default;